import SplitScreenContent from "../../components/SplitScreenContent";

export const motorRevision996to992 = {
  title: "Motorrevision für wassergekühlte Porsche-Modelle",
  titleImageUrl: "gallery/cars/watercooled_marketing/1_sb3ocu",
  meta: {
    title: "Porsche 996 / 997 / 991 Motorrevision – WTM Sportwagen",
    description:
      "Professionelle Motorrevision für wassergekühlte Porsche-Modelle wie 996, 997, 991, Boxster & Cayman. Fachgerechte Instandsetzung mit Originalteilen und deutschlandweitem Hol-/Bringservice.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323940/gallery/cars/watercooled_marketing/1_sb3ocu",
      headline: "Porsche Motorrevision wassergekühlt",
      description:
        "WTM Sportwagen ist spezialisiert auf die Instandsetzung und Optimierung von wassergekühlten Porsche-Motoren. Ob Carrera, Boxster oder Cayman – wir bieten kompromisslose Qualität für M96-, M97- und MA1-Triebwerke.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },

    {
      type: "text_section_hero",
      // headline: "Porsche Motorrevision wassergekühlt",
      lead: "WTM Sportwagen ist spezialisiert auf die Instandsetzung und Optimierung von wassergekühlten Porsche-Motoren. Ob Carrera, Boxster oder Cayman – wir bieten kompromisslose Qualität für M96-, M97- und MA1-Triebwerke.",
      highlight: "Wir bauen Motoren, die halten was sie versprechen.",
      spacing: "tight_top_comfortable_bottom",
      size: "lg",
      variant: "primary",
      margin: false,
    },
    {
      type: "split_screen_layout",
      leftImage: "gallery/cars/watercooled_marketing/2_kadusc",
      headline: "Motorrevision bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Motor-Revision Porsche 996 / 997 / 991"
          intro="Bei WTM Sportwagen steht jede Motorrevision für kompromisslose Qualität und handwerkliche Perfektion. Unser Fokus liegt auf wassergekühlten Porsche-Motoren der Baureihen 996, 997, 991 sowie Boxster und Cayman. Infos zu klassischen luftgekühlten Motoren finden Sie <a href='/motorenbau/motor-revision-356-911-964-993' class='hyperlink'>hier</a>."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Persönlich & Transparent",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Von Beginn an sind Sie Teil des Projekts: mit klarer Kommunikation, WhatsApp-Updates aus der Werkstatt und echtem persönlichen Austausch. So bleibt Ihre Motorrevision nachvollziehbar und vertrauensvoll.",
            },
            {
              type: "heading",
              text: "Moderne Technik, bewährte Lösungen",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Wassergekühlt bedeutet nicht kompliziert: Unsere Revisionen zeigen, wie sich moderne Porsche-Technik zuverlässig und dauerhaft instand setzen lässt – mit bewährten Lösungen für typische Probleme.",
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Motorrevision - Wassergekühlte Porsche",
      navbarHeight: 0,
    },

    {
      type: "cta-with-modal",
      headline: "Unverbindlich Motorrevision anfragen",
      paragraph:
        "Ein zuverlässiger Motor macht den Unterschied: Lassen Sie uns über Ihr Projekt sprechen. Wir melden uns persönlich und gehen alle Optionen mit Ihnen durch.",
      darkMode: true,
      spacing: "comfortable_top_tight_bottom",
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/cars/watercooled_marketing/4_k0yoc2",
      headline: "Spezialisierung & Expertise",
      rightContent: (
        <SplitScreenContent
          headline="Moderne Porsche-Motoren im Detail"
          intro="Wir kennen die Eigenheiten aller wassergekühlten Porsche-Triebwerke und stimmen jede Revision auf Modell und Einsatzzweck ab. Von originalgetreuer Revision bis zum Performance-Upgrade."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "996 Carrera (3.4 – 3.6 L)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Der erste wassergekühlte 911 mit bekannten Schwachstellen wie IMS-Lager und Nikasil-Laufbuchsen. Wir bieten bewährte Lösungen für dauerhaft zuverlässigen Betrieb.",
            },
            {
              type: "heading",
              text: "997 Carrera / S / GT3 (3.6 – 3.8 L)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Ausgereifter und robuster als der Vorgänger, aber mit eigenen Eigenheiten. Von Kolbenkipper-Problemen bis zu Performance-Upgrades kennen wir jeden Kniff.",
            },
            {
              type: "heading",
              text: "Boxster & Cayman (986 / 987 / 981)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Die Mittelmotoren von 2.5 bis 3.4 Liter bieten pure Fahrdynamik. Wir sorgen für langfristige Zuverlässigkeit und optimales Ansprechverhalten.",
            },
            {
              type: "heading",
              text: "Performance-Setups & Upgrades",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Individuelle Konzepte für mehr Leistung und besseres Ansprechverhalten – immer abgestimmt auf Fahrzeug, Einsatzzweck und Budget.",
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Motorrevision - Wassergekühlte Motoren",
      navbarHeight: 0,
    },
    {
      type: "split_screen_layout",
      leftImage: "gallery/engine_builds/964_4L/P1020568_wv3lro",
      headline: "Qualität & Vertrauen",
      rightContent: (
        <SplitScreenContent
          headline="Revision für Boxster, Cayman und 911"
          intro="Unsere Kunden kommen aus ganz Deutschland, darunter Frankfurt, Köln, München und Hamburg – weil sie Qualität, Erfahrung und kompromisslose Präzision erwarten."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Bewährte Lösungen für typische Probleme",
              level: 3,
            },
            {
              type: "paragraph",
              text: "IMS-Lager, Kolbenkipper, Nikasil-Laufbuchsen – wir kennen die Schwachstellen wassergekühlter Porsche-Motoren und bieten bewährte, dauerhafte Lösungen.",
            },
            {
              type: "heading",
              text: "Originalteile & Motorsport-Upgrades",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Verwendung von Originalteilen und bewährten Motorsport-Komponenten für optimale Zuverlässigkeit und Performance – je nach Einsatzzweck und Budget.",
            },
            {
              type: "heading",
              text: "Deutschlandweiter Service",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Versicherter Hol- und Bringservice für Fahrzeuge und Motoren deutschlandweit. Transparente Kommunikation und persönliche Betreuung von Anfang bis Ende.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Unsere Stärken",
                items: [
                  "Langjährige Erfahrung mit wassergekühlten Porsche-Motoren (996 bis 991, Boxster & Cayman)",
                  "Behebung typischer Probleme wie IMS-Lager, Kolbenkipper oder Nikasil-Laufbuchsen",
                  "Verwendung von Originalteilen und bewährten Motorsport-Upgrades",
                  "Versicherter Hol- und Bringservice für Fahrzeuge und Motoren deutschlandweit",
                ],
                highlightedIndices: [0, 1],
                icon: "check",
              },
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline:
                  "Jetzt Motorrevision besprechen – persönlich & unverbindlich",
                paragraph:
                  "Ob Komplettrevision oder gezielte Instandsetzung – wir sind persönlich für Sie da. Lassen Sie uns über Ihr Projekt sprechen.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Motorrevision - Qualität und Vertrauen",
      navbarHeight: 0,
    },

    // {
    //   type: "relevant-posts",
    //   postSlugs: [
    //     "porsche-m96-motorrevision",
    //     "ims-lager-upgrade-996-997",
    //     "typische-schaeden-m96-m97",
    //     "991-motor-technikupdate",
    //     "boxster-cayman-motorreparatur",
    //   ],
    //   headline: "Werkstatt Journal: Wassergekühlte Porsche-Motoren",
    //   introText:
    //     "Lesen Sie weitere Artikel und Einblicke rund um Motorrevision und Technik-Upgrades bei wassergekühlten Modellen.",
    //   darkMode: false,
    // },
  ],
};
